import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

import axios from "axios"
// @mui
import { styled } from '@mui/material/styles';
// component
import MakeGroupName from "../../../components/Create_Group/MakeGroupName";
import RegistPayment from "../../../components/Create_Group/RegistPayment";

// @mui

// ----------------------------------------------------------------------


const Div = styled('div')(({ theme }) => ({
  padding : '80px 10%',
  backgroundColor:'#f5f5f5',
  display:'flex',
  flex:1,

}));

// ----------------------------------------------------------------------

export default function LicenseRegist() {

  const navigate = useNavigate();
  const gotoLicencePage = () => {
    navigate('/license', { replace: true })
  }

  // 로그인 여부 체크 ------------------------------------------------------

  // useEffect(() => {

  //   if (!sessionStorage.getItem('login_info')) {
  //     alert('로그인 후 이용 가능합니다.');
  //     navigate('/login', { replace: true })
  //   } else {
  //     //
      
  //   }
  // }, []);

  // 컴포넌트 활성화 --------------------------------------------------

  // NEXT
  const [ namePage, activeNamePage ] = useState(true);
  const [ paymentPage, activePaymentPage ] = useState(false);

  // PRE
  const CancelWrite = (x) => {
    activePaymentPage(x);
    activeNamePage(true);

  }
 

  // 그룹 이름 설정 ---------------------------------------------------

  const [ inputName , setInputName ] = useState('')


  const setGroupName = ( name ) => {
    if( name.org_name !== '' ){
      console.log( '그룹이름' , name )
      setInputName(name); 
      activeNamePage(false);
      activePaymentPage(true);
    }
  }

  // ----------------------------------------------------------------

 
  return (
    <>
      <Helmet>
        <title> 라이센스 등록 | RainDrop </title>
      </Helmet>

      <Div>
        {/* <RegistPayment parentFunction={CancelWrite}/> */}
      { namePage && <MakeGroupName parentFunction={setGroupName}/> }
      { paymentPage && <RegistPayment parentFunction={CancelWrite}/> }
      </Div>


    </>
  );
}
